import * as React from 'react';
import styled from 'styled-components';

import { useAppSelector } from '@/redux/hooks';
import { getCatalogLotsListed } from '@/redux/modules/catalog/catalogs/catalog.selectors';
import { getLiveCatalogCurrentItemIndex } from '@/redux/modules/console';

type Props = {
    catalogId: number;
};

const ProgressBar = ({ catalogId }: Props) => {
    const lotsListed = useAppSelector((state) => getCatalogLotsListed(state, catalogId));
    const itemIndex = useAppSelector((state) => getLiveCatalogCurrentItemIndex(state, catalogId));

    const percentage = Math.round(((itemIndex + 1) / lotsListed) * 100);

    return (
        <PercentageMeter percentage={percentage}>
            <span />
        </PercentageMeter>
    );
};

export default ProgressBar;

const PercentageMeter = styled.div<{ percentage: number }>`
    background-color: ${({ theme }) => theme.colors.grey400};
    flex: 1 1 auto;
    height: 5px;

    span {
        background-color: ${({ theme }) => theme.colors.red300};
        display: block;
        height: 100%;
        width: ${({ percentage }) => `${percentage}%`};
        transition: all 0.25s;
    }
`;
